module.exports = __webpack_public_path__ + "fonts/Rubik-500-latin75.b65daad.woff2";